import React from 'react'
import { Box, Divider } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    marginTop: 'auto',
    width: '100%'
  }
}))

const LpqFooter = ({ children }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Divider />
      {children}
    </Box>
  )
}

export default LpqFooter
